<template>
  <div class="compatibility-list vehicle-info-compatibility-list">
    <div class="compatibility-table-scroll">
      <div class="compatibility-table-grid" :style="tableStyle">
        <div class="compatibility-table-header" :style="gridStyle">
          <div
            v-for="column in columns"
            :key="column"
            class="compatibility-table-heading"
            :class="{ 'compatibility-status-column': statusColumns.includes(column) }"
          >
            {{ $t(`checker.legends.${column}`) }}
          </div>
        </div>
        <div class="compatibility-list-content-wrapper">
          <div
            v-for="(compatibility, index) in compatibilities"
            :key="`vehicle-info-${index}`"
            class="compatibility-table-row"
          >
            <CompatibilityInformation
              :compat="compatibility.response"
              :request="compatibility.request"
              :columns="columns"
              :gridStyle="gridStyle"
              :rowIndex="index"
              tableType="vehicleInfo"
              :isUpdating="updatingRows.includes(index)"
              @resubmitVehicleInfo="emit('resubmitVehicleInfo', $event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { VehicleInfoCompatibility, VehicleInfoRequest } from '../vehicleInfo';
import CompatibilityInformation from './CompatibilityInformation.vue';
import {
  compatibilityStatusColumns,
  compatibilityTableColumns
} from './tableColumns';
import './styles/compatibility-table.scss';
import './styles/vehicle-info-compatibility-table.scss';

defineProps<{
  compatibilities: VehicleInfoCompatibility[];
  updatingRows: number[];
}>();

const emit = defineEmits<{(event: 'resubmitVehicleInfo', payload: {
    rowIndex: number;
    request: VehicleInfoRequest;
  }): void;
}>();

const columns = compatibilityTableColumns.vehicleInfo;
const statusColumns = compatibilityStatusColumns;
const gridStyle = computed(() => ({
  gridTemplateColumns: `repeat(${columns.length}, minmax(120px, 1fr))`
}));
const tableStyle = computed(() => ({ minWidth: `${columns.length * 150}px` }));
</script>
